import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { Button, Checkbox, notification, Spin, Tooltip } from 'antd';

import { Edit, Info } from '../../../assets/icons';

import { getUserProfileApi, kycAmlVerify } from '../../../services/authApi/userApi';
import KycIdentityUploadModal from './KycIdentityUploadModal';
import { addUserData } from '../../../store/reducer/accountSlice';
import { dwollaAgreementsAction } from '../../../store/reducer/onbordingSlice';
import { decryptEIN, maskEIN } from '../../../utils/einDecryption';
import { formatePhoneNumber } from '../../../utils/formatPhoneNumber';
import { toastNotify } from '../../../utils/toastNotify';
import { DWOLLA_LINKS_POLICY_LINK, INVESTMENT_RANGE_OPTIONS } from '../../../utils/constant';
import { POLICY_AGREEMENTS_TITLE } from '../../../utils/policy.constants';
import { ACCOUNT_TYPES } from '../../../constants/accountType.constants';

const StepSix = (props) => {
  const [loading, setLoading] = useState(false);
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);
  const { userData: userProfile } = useSelector((state) => state.userData);
  const { loading: agreementLoading } = useSelector((state) => state.dwollaAgreement);
  const [isRealbricksAgreementChecked, setIsRealbricksAgreementChecked] = useState(false);
  const [showIdentityModal, setShowIdentityModal] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const getUserProfile = async () => {
    setLoading(true);
    try {
      const resData = await getUserProfileApi();

      if (!resData.isError) {
        const { data } = resData;
        dispatch(addUserData({ userData: data?.user }));
        navigate('/sign-up/linkbank');
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const isEntity = userProfile?.accountType === ACCOUNT_TYPES.ENTITY;

  const residentialAdd = userProfile?.address?.residentialAdd || '';
  const apartmentNumber = userProfile?.address?.apartmentNumber || '';
  const city = userProfile?.address?.city;
  const state = userProfile?.address?.state;
  const zipCode = userProfile?.address?.zipCode;

  // let { residentialAdd, apartmentNumber, city, state, zipCode } = Object.keys(userProfile).length > 0 && userProfile?.address;
  const addressDeatilOne = userProfile ? `${residentialAdd}, ${apartmentNumber}` : '';
  const addressDeatilTwo = userProfile ? `${city}, ${state}, ${zipCode}` : '';

  const entityResidentialAdd = userProfile?.entityProfile?.entityAddress?.residentialAdd || '';
  const entityApartmentNumber = userProfile?.entityProfile?.entityAddress?.apartmentNumber || '';
  const entityCity = userProfile?.entityProfile?.entityAddress?.city;
  const entityState = userProfile?.entityProfile?.entityAddress?.state;
  const entityZipCode = userProfile?.entityProfile?.entityAddress?.zipCode;
  const entityAddressDetailOne = userProfile ? `${entityResidentialAdd}, ${entityApartmentNumber}` : '';
  const entityAddressDetailTwo = userProfile ? `${entityCity}, ${entityState}, ${entityZipCode}` : '';

  const phoneNumber = [userProfile?.countryCode, formatePhoneNumber(userProfile?.phoneNumber)];
  const ssnFormate = userProfile && userProfile.ssn ? `XXX-XX-X${userProfile.ssn.slice(8, 11)}` : '';
  const einFormate = maskEIN(decryptEIN(userProfile?.entityProfile?.encodedEIN));
  const legalName = [userProfile?.firstName, ' ', userProfile?.lastName];
  const userProfileData = useSelector((state) => state.userData);

  const getInvestmentRangeDisplay = (investmentRange) =>
    INVESTMENT_RANGE_OPTIONS.find((option) => option.value === investmentRange)?.label || investmentRange || 'NA';

  const stepSixData = [
    {
      title: 'Legal Name',
      detail1: legalName,
      step: 'StepOne',
      isEdited: false,
      isLegalTooltip: true,
    },
    ...(isEntity
      ? [
          {
            title: 'Entity Name',
            detail1: userProfile?.entityProfile?.entityName,
            step: 'StepTwo',
            isEdited: false,
            isEntityNameTooltip: true,
          },
        ]
      : []),
    {
      title: 'Email',
      detail1: userProfile?.email,
      step: 'StepOne',
      isEdited: false,
      isEmailTooltip: true,
    },
    {
      title: 'Country of Residence',
      detail1: 'USA',
      step: 'StepOne',
      isEdited: false,
    },
    {
      title: 'Residential Address',
      detail1: addressDeatilOne,
      detail2: addressDeatilTwo,
      step: 'StepTwo',
      isEdited: true,
    },
    ...(isEntity
      ? [
          {
            title: 'Entity Address',
            detail1: entityAddressDetailOne,
            detail2: entityAddressDetailTwo,
            step: 'StepTwo',
            isEdited: true,
          },
        ]
      : []),
    {
      title: 'Phone Number',
      detail1: phoneNumber,
      step: 'StepTwo',
      isEdited: false,
      isPhoneNoTooltip: true,
    },
    {
      title: 'SSN',
      detail1: ssnFormate,
      step: 'StepThree',
      isEdited: true,
    },
    ...(isEntity
      ? [
          {
            title: 'EIN',
            detail1: einFormate || 'NA',
            step: 'StepThree',
            isEdited: true,
          },
        ]
      : []),
    {
      title: 'Date Of Birth',
      // detail1: '10/08/1975',
      detail1: userProfile?.dob,
      step: 'StepThree',
      isEdited: true,
    },
    ...(isEntity
      ? [
          {
            title: 'Entity Type',
            detail1: userProfile?.entityProfile?.entityType,
            isEdited: false,
            isEntityTypeTooltip: true,
          },
        ]
      : []),
    {
      title: 'Your Investment Preferences',
      // detail1: accreStatus ? 'Accredited' : 'Not Accredited',
      detail1: getInvestmentRangeDisplay(userProfileData?.userData?.investmentPreference?.investmentRange),
      step: 'StepFour',
      isEdited: true,
    },
  ];

  const showVerificationInProgressNotification = () => {
    notification.error({
      description: (
        <span>
          Identity verification in progress. Please contact{' '}
          <a href='mailto:support@realbricks.com'>support@realbricks.com</a>
          {' '}or call{' '}
          <a href='tel:9862195819'>986-219-5819</a>
          {' '}for verification status.
        </span>
      ),
      duration: 8,
      placement: 'bottomRight',
    });
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      // First call Dwolla agreement API
      await dispatch(
        dwollaAgreementsAction({
          onSuccess: async () => {
            // Only proceed with KYC verification if Dwolla agreement succeeds
            try {
              const userData = await kycAmlVerify();
              if (!userData.isError) {
                const { isAMLApproved, isDocRequiredForAml } = userData?.data || {};
                if (!isAMLApproved && isDocRequiredForAml) {
                  // AML not approved and document required — show identity upload modal
                  setLoading(false);
                  setShowIdentityModal(true);
                } else {
                  toastNotify('success', userData?.message);
                  getUserProfile();
                }
              } else {
                showVerificationInProgressNotification();
              }
            } catch (error) {
              const { response } = error;
              if (response?.data?.message === 'Identity is already verified.') {
                notification.success({
                  description: response?.data?.message,
                  duration: 5,
                  placement: 'bottomRight',
                });
              } else {
                showVerificationInProgressNotification();
              }
              navigate('/account');
            } finally {
              setLoading(false)
            }
          },
          onError: () => {
            showVerificationInProgressNotification();
            setLoading(false);
          }
        })
      );
    } catch (error) {
      toastNotify('error', 'An error occurred during the process');
    }
  };

  const handleClickOnAgreement = () => {
    // Remove API call, just toggle the checkbox state
    setIsAgreementChecked(!isAgreementChecked);
  };

  const handleClickOnRealbricksAgreement = () => {
    setIsRealbricksAgreementChecked(!isRealbricksAgreementChecked);
  };

  return (
    <>
      {userProfileData?.userData?.isKYCVerified && !(!userProfileData?.userData?.isAMLApproved && userProfileData?.userData?.isDocRequiredForAml) ? (
        <>
          <p>you have already been verified please go to home</p>
          <Button href='/' type='primary'>
            Realbricks Marketplace
          </Button>
        </>
      ) : (
        <div className='stepsix review'>
          <div className='review__list'>
            {stepSixData.map((data, index) => (
              <div className='review__item' key={index}>
                <div>
                  <span className='review__title'>{data.title}</span>
                  <p className='mb-0 fw-500 review__detail'>{data.detail1}</p>
                  {data.detail2 && <p className='mb-0 fw-500 review__detail'>{data.detail2}</p>}
                </div>
                {data.isLegalTooltip && (
                  <Tooltip
                    placement='leftBottom'
                    className='fw-600 review__edit'
                    title={
                      <>
                        <p>
                          Legal name is editable once you completed onboarding. If you wish to edit now. Please contact{' '}
                          <a href='mailto:support@realbricks.com'>support@realbricks.com</a>
                        </p>
                      </>
                    }
                  >
                    {' '}
                    <Info marginLeft='7px' top='5px' className='fw-600 review__edit' size={18} />{' '}
                  </Tooltip>
                )}
                {data.isEntityNameTooltip && (
                  <Tooltip
                    placement='leftBottom'
                    className='fw-600 review__edit'
                    title={
                      <>
                        <p>
                          Entity name is editable once you completed onboarding. If you wish to edit now. Please contact{' '}
                          <a href='mailto:support@realbricks.com'>support@realbricks.com</a>
                        </p>
                      </>
                    }
                  >
                    {' '}
                    <Info marginLeft='7px' top='5px' className='fw-600 review__edit' size={18} />{' '}
                  </Tooltip>
                )}
                {data.isEntityTypeTooltip && (
                  <Tooltip
                    placement='leftBottom'
                    className='fw-600 review__edit'
                    title={
                      <>
                        <p>
                          Entity type is editable once you completed onboarding. If you wish to edit now. Please contact{' '}
                          <a href='mailto:support@realbricks.com'>support@realbricks.com</a>
                        </p>
                      </>
                    }
                  >
                    {' '}
                    <Info marginLeft='7px' top='5px' className='fw-600 review__edit' size={18} />{' '}
                  </Tooltip>
                )}
                {data.isEmailTooltip && (
                  <Tooltip
                    placement='leftBottom'
                    className='fw-600 review__edit'
                    title={
                      <>
                        <p>
                          Email is editable once you completed onboarding. If you wish to edit now. Please contact{' '}
                          <a href='mailto:support@realbricks.com'>support@realbricks.com</a>
                        </p>
                      </>
                    }
                  >
                    {' '}
                    <Info marginLeft='7px' top='5px' className='fw-600 review__edit' size={18} />{' '}
                  </Tooltip>
                )}
                {data.isPhoneNoTooltip && (
                  <Tooltip
                    placement='leftBottom'
                    className='fw-600 review__edit'
                    title={
                      <p>
                        Phone Number is editable once you completed onboarding. If you wish to edit now. Please contact{' '}
                        <a href='mailto:support@realbricks.com'>support@realbricks.com</a>
                      </p>
                    }
                  >
                    {' '}
                    <Info marginLeft='7px' top='5px' className='fw-600 review__edit' size={18} />{' '}
                  </Tooltip>
                )}
                {data.isEdited && (
                  <div className='fw-600 review__edit' onClick={() => props.nextAction(data.step)}>
                    <Edit verticalAlign='middle' marginRight='8px' top='-2px' /> <span>Edit</span>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className='mt-16'>
            {agreementLoading ?
              <Spin className='mr-8' spinning={agreementLoading} /> :
              <Checkbox
                className='mr-8'
                checked={isAgreementChecked}
                onChange={() => handleClickOnAgreement()}
              />
            }
            <span>
              I have read and agree to Dwolla's{' '}
              <a
                href={DWOLLA_LINKS_POLICY_LINK.PRIVACY_POLICY}
                className='fw-600 underline'
                target='_blank'
                rel='noopener noreferrer'
                onClick={(e) => e.stopPropagation()}
              >
                Privacy Policy
              </a>
              <a
                href={DWOLLA_LINKS_POLICY_LINK.PRIVACY_POLICY}
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none' }}
                onClick={(e) => e.stopPropagation()}
              >
                <Edit
                  verticalAlign='middle'
                  marginLeft='4px'
                  top='-1px'
                  size={14}
                  style={{ cursor: 'pointer', color: 'inherit' }}
                  aria-label="Edit Privacy Policy"
                />
              </a>
              {' '}and{' '}
              <a
                href={DWOLLA_LINKS_POLICY_LINK.TERMS_AND_CONDITIONS}
                className='fw-600 underline'
                target='_blank'
                rel='noopener noreferrer'
                onClick={(e) => e.stopPropagation()}
              >
                Terms and Conditions
              </a>
              <a
                href={DWOLLA_LINKS_POLICY_LINK.TERMS_AND_CONDITIONS}
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none' }}
                onClick={(e) => e.stopPropagation()}
              >
                <Edit
                  verticalAlign='middle'
                  marginLeft='4px'
                  top='-1px'
                  size={14}
                  style={{ cursor: 'pointer', color: 'inherit' }}
                  aria-label="Edit Terms and Conditions"
                />
              </a>
              .
            </span>
          </div>

          <div className='mt-16'>
            {agreementLoading ?
              <Spin className='mr-8' spinning={agreementLoading} /> :
              <Checkbox
                className='mr-8'
                checked={isRealbricksAgreementChecked}
                onChange={handleClickOnRealbricksAgreement}
              />
            }
            <span>
              I have read and agree to Realbricks'{' '}
              <a
                href={`/legal#${POLICY_AGREEMENTS_TITLE.EFTA}`}
                className='fw-600 underline'
                target='_blank'
                rel='noopener noreferrer'
                onClick={(e) => e.stopPropagation()}
              >
                Electronic Funds Transfers Agreement
              </a>
              <a
                href={`/legal#${POLICY_AGREEMENTS_TITLE.EFTA}`}
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none' }}
                onClick={(e) => e.stopPropagation()}
              >
                <Edit
                  verticalAlign='middle'
                  marginLeft='4px'
                  top='-1px'
                  size={14}
                  style={{ cursor: 'pointer', color: 'inherit' }}
                  aria-label="Edit Electronic Funds Transfers Agreement"
                />
              </a>
              {' '}and{' '}
              <a
                href={`/legal#${POLICY_AGREEMENTS_TITLE.DISCLOSURE}`}
                className='fw-600 underline'
                target='_blank'
                rel='noopener noreferrer'
                onClick={(e) => e.stopPropagation()}
              >
                Disclosure Regulation A Investment Disclosure
              </a>
              <a
                href={`/legal#${POLICY_AGREEMENTS_TITLE.DISCLOSURE}`}
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none' }}
                onClick={(e) => e.stopPropagation()}
              >
                <Edit
                  verticalAlign='middle'
                  marginLeft='4px'
                  top='-1px'
                  size={14}
                  style={{ cursor: 'pointer', color: 'inherit' }}
                  aria-label="Edit Disclosure Regulation A Investment Disclosure"
                />
              </a>
              {' '}
              <a
                href={`/legal#${POLICY_AGREEMENTS_TITLE.SECONDARY_LISTING_AGREEMENT}`}
                className='fw-600 underline'
                target='_blank'
                rel='noopener noreferrer'
                onClick={(e) => e.stopPropagation()}
              >
                <>Secondary Listing Agreement </>
              </a>
              <a
                href={`/legal#${POLICY_AGREEMENTS_TITLE.SECONDARY_LISTING_AGREEMENT}`}
                target='_blank'
                rel='noopener noreferrer'
                style={{ textDecoration: 'none' }}
                onClick={(e) => e.stopPropagation()}
              >
                <Edit
                  verticalAlign='middle'
                  marginLeft='4px'
                  top='-1px'
                  size={14}
                  style={{ cursor: 'pointer', color: 'inherit' }}
                  aria-label="Edit Secondary Listing Agreement"
                />
              </a>
              .
            </span>
          </div>
          <div className='auth-form__fixed-submit'>
            <Button disabled={!isAgreementChecked || !isRealbricksAgreementChecked} loading={loading} type='primary' className='ant-btn-primary--alt'>
              <Link className='text-white' onClick={() => handleConfirm()}>
                Confirm
              </Link>
            </Button>
          </div>
        </div>
      )}
      <KycIdentityUploadModal
        visible={showIdentityModal}
        onClose={() => setShowIdentityModal(false)}
        onSuccess={() => {
          setShowIdentityModal(false);
          getUserProfile();
        }}
      />
    </>
  );
};

StepSix.propTypes = {
  nextAction: PropTypes.func,
};

export default StepSix;
